module.exports = __webpack_public_path__ + "static/img/AdobeStock_317642058_1.61acfaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_design/AdobeStock_317642058_1.png
// module id = 91
// module chunks = 1